const formatNumber = (number: number, prefix = '', suffix = '') => {
  if (number === undefined || number === null) return '';
  return prefix + number.toLocaleString('ja-JP', { maximumFractionDigits: 4 }) + suffix;
};
export default formatNumber;
